/**
 * Logout utilities for handling cleanup and redirection
 */
import { clearTravelerMapCache } from '../map/utils/cacheUtils';

/**
 * Performs logout cleanup and redirects to logout endpoint
 * This function should be called when a user logs out to ensure
 * all client-side data is properly cleared
 */
export const performLogout = (): void => {
  try {
    // Clear traveler map cache to prevent data leakage between users
    clearTravelerMapCache();
    
    // Redirect to server logout endpoint
    window.location.href = '/logout';
  } catch (error) {
    console.error('Error during logout cleanup:', error);
    // Even if cleanup fails, still proceed with logout
    window.location.href = '/logout';
  }
};

/**
 * Handles logout for traveler users with specific cleanup
 */
export const performTravelerLogout = (): void => {
  try {
    // Clear traveler map cache
    clearTravelerMapCache();
    
    // For traveler users, we might have different logout handling
    // For now, use the same logout endpoint
    window.location.href = '/logout';
  } catch (error) {
    console.error('Error during traveler logout cleanup:', error);
    // Even if cleanup fails, still proceed with logout
    window.location.href = '/logout';
  }
};